import Chart from 'react-apexcharts';
import type { ApexOptions } from 'apexcharts';
import type { ChartData } from '@yawi/types';

interface TenantGrowthChartProps {
  data: ChartData;
  isLoading?: boolean;
}

export function TenantGrowthChart({ data, isLoading }: TenantGrowthChartProps) {
  const options: ApexOptions = {
    legend: {
      show: true,
      position: 'top',
      horizontalAlign: 'left',
    },
    colors: ['#8B5CF6', '#F59E0B'],
    chart: {
      fontFamily: 'Outfit, sans-serif',
      height: 310,
      type: 'bar',
      toolbar: {
        show: false,
      },
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: '55%',
        borderRadius: 4,
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      show: true,
      width: 2,
      colors: ['transparent'],
    },
    grid: {
      xaxis: {
        lines: {
          show: false,
        },
      },
      yaxis: {
        lines: {
          show: true,
        },
      },
    },
    tooltip: {
      enabled: true,
    },
    xaxis: {
      type: 'category',
      categories: data.labels,
      axisBorder: {
        show: false,
      },
      axisTicks: {
        show: false,
      },
    },
    yaxis: {
      labels: {
        style: {
          fontSize: '12px',
          colors: ['#6B7280'],
        },
      },
    },
  };

  const series = data.datasets.map((dataset) => ({
    name: dataset.name,
    data: dataset.data,
  }));

  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-[310px]">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-brand-500"></div>
      </div>
    );
  }

  return (
    <div className="rounded-2xl border border-gray-200 bg-white p-5 dark:border-gray-800 dark:bg-white/[0.03] md:p-6">
      <h3 className="text-lg font-semibold text-gray-800 dark:text-white/90 mb-4">
        Tenant Growth
      </h3>
      <div className="max-w-full overflow-x-auto custom-scrollbar">
        <div className="min-w-[600px]">
          <Chart options={options} series={series} type="bar" height={310} />
        </div>
      </div>
    </div>
  );
}
